export default __webpack_public_path__ + "static/media/ISKO CLASS-7 EXAM PATTERN 2025.934c67bb.pdf";